import { AfterViewInit, ComponentRef, Directive, ElementRef, inject, input, InputSignal, ViewContainerRef } from '@angular/core';
import { IconComponent, IconModule } from '@ogs-gmbh/ngx-m3-components';

@Directive({
  selector: '[ogsDisabled]',
  standalone: true
})
export class OgsDisabledDirective implements AfterViewInit {
  private elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef);

  private viewContainerRef: ViewContainerRef = inject<ViewContainerRef>(ViewContainerRef);

  ogsDisabled: InputSignal<boolean | ''> = input<boolean | ''>('');

  ngAfterViewInit (): void {
    const nativeEl: HTMLElement = this.elementRef.nativeElement;
    const fieldWrapper: Element | null = nativeEl.querySelector('.mat-mdc-text-field-wrapper');

    if (!fieldWrapper) return;

    const iconComponentRef: ComponentRef<IconModule> = this.viewContainerRef.createComponent(IconComponent);

    iconComponentRef.setInput('prefix', 'fal');
    iconComponentRef.setInput('icon', 'lock');

    const iconEl: HTMLElement = iconComponentRef.location.nativeElement as HTMLElement;

    iconEl.style.position = 'absolute';
    iconEl.style.right = '12px';
    iconEl.style.top = '50%';
    iconEl.style.transform = 'translateY(-50%)';
    iconEl.style.pointerEvents = 'none';
    iconEl.style.color = 'rgba(0, 0, 0, 0.38)';
    fieldWrapper.append(iconEl);

    if (this.ogsDisabled() === '' || this.ogsDisabled() === true) {
      const control: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null = nativeEl.querySelector<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >('input, textarea, select');

      if (control)
        control.disabled = true;


      // Material-Disabled-Styles erzwingen
      nativeEl.classList.add('mat-mdc-form-field-disabled');
    }
  }
}
